import { Navigate } from "react-router-dom";
// import { AuthContext } from "../context/Auth";
import { useUserStatus } from "../context/UserStatusContext";
import { isSubscriptionAccessBlocked } from "../utils/subscriptionStatus";

const PrivateRouteStatus = ({ children }) => {
//   const { currentUser } = useContext(AuthContext);
const { userStatus } = useUserStatus();
  console.log(userStatus,"PrivateRoute status")



  return userStatus && !isSubscriptionAccessBlocked(userStatus) ? children : <Navigate to="/settings" replace />;
};

export default PrivateRouteStatus;
